
import { mapGetters } from 'vuex'
import SizeGuide from '~/components/size-guide/lole-size-guide.vue'
export default {
  components: { SizeGuide },
  computed: {
    ...mapGetters({
      wordingSizeGuide: 'common/getSizeGuide',
    }),
    openSizeGuideAt() {
      if (!this.gender) return 0
      if (this.gender === 'men') return 1
      if (this.gender === 'pets') return 2
      return 0
    },
  },
}
